import { Blossom } from "@blossom-carousel/core";

const arrowLeft = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
	<path d="M8.66 19L3.5 10L8.66 1" stroke="currentColor" stroke-width="2.5" />
	<path d="M3.5 10H16.5" stroke="currentColor" stroke-width="2.5" />
</svg>`;

const arrowRight = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
	<path d="M11.34 19L16.5 10L11.34 1" stroke="currentColor" stroke-width="2.5" />
	<path d="M16.5 10H3.5" stroke="currentColor" stroke-width="2.5" />
</svg>`;

export class Carousel {
	constructor() {
		this.init();
	}

	init() {
		document.querySelectorAll("[data-carousel]").forEach((viewport) => {
			try {
				const items = viewport.querySelectorAll(".carousel__item");

				// Only initialize carousel if there are multiple items
				if (items.length > 1) {
					Blossom(viewport).init();
					this.setupCarousel(viewport, items);
				}
			} catch (error) {
				console.warn(
					"Carousel initialization failed for viewport:",
					viewport,
					error
				);
			}
		});
	}

	setupCarousel(viewport, items) {
		try {
			const carousel = viewport.parentNode;
			const firstItem = items[0];
			const lastItem = items[items.length - 1];

			// Create arrow navigation
			carousel.insertAdjacentHTML(
				"beforeend",
				`<nav class="carousel__nav" aria-label="Slider-Navigation">
					<button class="carousel__arrow carousel__prev" type="button" aria-label="Vorheriges Bild" disabled>${arrowLeft}</button>
					<button class="carousel__arrow carousel__next" type="button" aria-label="Nächstes Bild">${arrowRight}</button>
				</nav>`
			);

			const prevBtn = carousel.querySelector(".carousel__prev");
			const nextBtn = carousel.querySelector(".carousel__next");

			// Get item width for scrolling
			const getItemWidth = () => items[0].offsetWidth;

			prevBtn.addEventListener("click", () => {
				viewport.scrollBy({ left: -getItemWidth(), behavior: "smooth" });
			});

			nextBtn.addEventListener("click", () => {
				viewport.scrollBy({ left: getItemWidth(), behavior: "smooth" });
			});

			// Track first/last visibility for button states
			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.target === firstItem) {
							prevBtn.disabled = entry.isIntersecting;
						}
						if (entry.target === lastItem) {
							nextBtn.disabled = entry.isIntersecting;
						}
					});
				},
				{
					root: viewport,
					threshold: 0.9,
				}
			);

			observer.observe(firstItem);
			observer.observe(lastItem);
		} catch (error) {
			console.warn("Carousel setup failed for viewport:", viewport, error);
		}
	}
}
